import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import type { ReactNode } from 'react';

import { PackageTypeIcon } from './package-type-icon';
import s from './package-type-identifier.scss';

export interface PackageTypeIdentifierProps {
  /**
   * Content rendered alongside the icon (e.g. package name, version label).
   */
  children: ReactNode;
  /**
   * Optional additional CSS class name applied to the root element.
   */
  className?: string;
  /**
   * Forwarded to `PackageTypeIcon` — CSS length controlling the icon's box
   * dimensions. Defaults to the icon component's own default.
   */
  size?: string;
  /**
   * The package type identifier used to resolve the icon and tooltip.
   */
  type: string;
}

/**
 * Renders a package type icon alongside arbitrary content in a horizontally
 * aligned layout. Standardises icon sizing and alignment so consumers don't
 * need to manage it themselves.
 */
export const PackageTypeIdentifier = ({
  children,
  className,
  size,
  type,
}: PackageTypeIdentifierProps) => {
  useStyles(s);

  return (
    <span className={classNames(s.root, className)}>
      <PackageTypeIcon size={size} type={type} />
      {children}
    </span>
  );
};

export default PackageTypeIdentifier;
